<template>
    <div v-if="usuario != null">
        <b-row>
            <b-col md="12" class="d-flex gap-sm">
                <strong>Nome: </strong>
                <span>{{ usuario.nome ? usuario.nome : usuario.razaoSocial  }}</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" class="d-flex gap-sm">
                <strong>Email: </strong>
                <span>{{ usuario.email }}</span>
            </b-col>
        </b-row>
    </div>
</template>


<script>

export default {
	components: { },
	name: "InformacoesUsuario",
	props: [ "usuario" ],
	data() {
		return {
		};
	},
	methods: {

	},

};
</script>



// WEBPACK FOOTER //
// src/components/usuario/InformacoesUsuario.vue